import React, { FC, useState } from "react";
import "../GridItem.scss";
import { GridItemProps } from "../GridItem.types";
import { CheckBox } from "../../Checkbox/Checkbox";
/**
 * The grid item component can be used to display new grid items and alters
 * the elements displayed in a grid.
 *
 */
export const GridItemProject: FC<GridItemProps> = ({
  label,
  date,
  gridItemName,
  onChange,
  gridItemCheckLabel,
  gridItemChecked,
  dataTestId,
  checkBoxStyle,
  onClick,
  checkBoxWrapperClass,
  backGroundDom,
  dropDownDOM,
  gridWrapperClassName,
  width,
  height,
  headerIconsArray,
  footerIconsArray,
  showCheckbox,
}) => {
  const gridItemCheckBox = `alteon-grid-item-project-checkbox ${checkBoxStyle}`;
  const [iconsHiddenClassName, setIconsHiddenClassName] = useState<string>(
    'alteon-project-icons-hidden'
  );
  const showButton = (e) => {
    e.preventDefault();
    setIconsHiddenClassName('');
  };

  const hideButton = (e) => {
    e.preventDefault();
    setIconsHiddenClassName('alteon-project-icons-hidden');
  };

  return (
    <div
      onMouseEnter={(e) => showButton(e)}
      onMouseLeave={(e) => hideButton(e)}
      data-testid={dataTestId}
      onClick={onClick}
      className={`alteon-grid-item-project-container ${gridWrapperClassName}`}
      style={{
        width: width || "22rem",
        height: height || "14rem",
        backgroundColor: !backGroundDom && "#333",
      }}
    >
      <div className="grid-background-image-dom">{backGroundDom}</div>
      <div className="grid-header-nav">
        {showCheckbox && (
          <CheckBox
            checked={gridItemChecked}
            onChange={onChange}
            label={gridItemCheckLabel}
            name={gridItemName}
            dataTestId={"alteon-checkbox-test-id-grid-item-project"}
            checkBoxClassName={gridItemCheckBox}
            className={checkBoxWrapperClass}
          />
        )}
        <div className={`alteon-grid-header-buttons ${iconsHiddenClassName}`}>
          {headerIconsArray && headerIconsArray.length > 0 && (
            <div className="alteon-grid-header-icons">
              {headerIconsArray.map((icon) => {
                return typeof icon === "string" ? (
                  <img
                    className="alteon-grid-item-folder-icon-class"
                    src={icon}
                  />
                ) : (
                  <div className="alteon-grid-item-folder-icon-class">
                    {icon}
                  </div>
                );
              })}
            </div>
          )}
          <div className="alteon-project-ellipsis">{dropDownDOM}</div>
        </div>
      </div>
      <div className="alteon-grid-item-project">
        <div className={`alteon-grid-item-project-label-overlay`}>
          <div
            className={`alteon-grid-item-project-label`}
            title={label || "Default- Label"}
          >
            {label ? label : "Default Label "}
            <div className={`alteon-grid-item-project-label-date`}>
              {date ? date : "5.31.2022 4:00 PM"}
            </div>
          </div>

          {footerIconsArray && footerIconsArray.length > 0 && (
            <div
              className={`alteon-grid-project-item-status-icons-parent ${iconsHiddenClassName}`}
            >
              {footerIconsArray.map((icon) => {
                return typeof icon === "string" ? (
                  <img
                    className="alteon-grid-item-folder-icon-class"
                    src={icon}
                  />
                ) : (
                  <div className="alteon-grid-item-folder-icon-class">
                    {icon}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

GridItemProject.defaultProps = {
  shape: "rounded",
  width: "24.25rem",
};
